import FinanceAdapter from './base';

export default class LineItem extends FinanceAdapter {
  modelNamePlural = 'lineItems';
}
